import type { ClientOptions } from "@/.generated/hey/v4b-backend/client";

import { createClient, createConfig } from "@/.generated/hey/v4b-backend/client";

export function createV4bClient(env: Required<Pick<ImportMetaEnv, "VITE_KILI_BASE_URL">>) {
  const client = createClient(
    createConfig<ClientOptions>({
      baseUrl: env.VITE_KILI_BASE_URL,
      credentials: "include",
    }),
  );

  client.interceptors.request.use((request) => {
    request.headers.set("VoltalisApplication", "HospitalityClient");

    return request;
  });

  return client;
}
